module.exports = __webpack_public_path__ + "static/media/J-logo.3571ca7b.png";